import { useState, useCallback } from 'react';

export const useDashboardModals = () => {
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [showNLComponentModal, setShowNLComponentModal] = useState(false);
  const [componentToUpdate, setComponentToUpdate] = useState(null);
  
  // 대시보드 충돌 모달 상태 추가
  const [showConflictModal, setShowConflictModal] = useState(false);
  const [conflictInfo, setConflictInfo] = useState(null);
  const [conflictTemplate, setConflictTemplate] = useState(null);

  const openOptionsModal = useCallback(() => setShowOptionsModal(true), []);
  const closeOptionsModal = useCallback(() => setShowOptionsModal(false), []);

  const openNLComponentModal = useCallback((component) => {
    // component가 null이면 새 컴포넌트 생성 모드
    // component가 있으면 기존 컴포넌트 수정 모드
    setComponentToUpdate(component);
    setShowNLComponentModal(true);
  }, []);

  const closeNLComponentModal = useCallback(() => {
    setShowNLComponentModal(false);
    setComponentToUpdate(null); // Reset componentToUpdate when modal closes
  }, []);
  
  // 충돌 모달 관련 함수들
  const openConflictModal = useCallback((conflictData, template) => {
    setConflictInfo(conflictData);
    setConflictTemplate(template);
    setShowConflictModal(true);
  }, []);

  const closeConflictModal = useCallback(() => {
    setShowConflictModal(false);
    setConflictInfo(null);
    setConflictTemplate(null);
  }, []);

  return {
    showOptionsModal,
    openOptionsModal,
    closeOptionsModal,
    showNLComponentModal,
    openNLComponentModal,
    closeNLComponentModal,
    componentToUpdate,
    // 충돌 모달 관련 상태와 함수들 추가
    showConflictModal,
    conflictInfo,
    conflictTemplate,
    openConflictModal,
    closeConflictModal,
  };
}; 